module.exports = __webpack_public_path__ + "img/xmas-head.8676c56.webp";